import React from 'react';
import PropTypes from 'prop-types';
import { FullWidthPaperContent } from 'components/Paper';
import styled from 'styled-components';
import WidgetContainer from 'components/widget/WidgetContainer';
import Button from 'components/Button';
import InfoButton from 'components/InfoButton';
import { useHistory } from 'react-router';
import changeBankDetailsContainerPath from 'containers/paths/ChangeBankDetailsContainerPath';

const StyledPaymentMethodWidgetDetails = styled(WidgetContainer)`
  .subscriptionInfo {
    margin-top: ${({ theme }) => theme.spacing * 2}px;
    padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 4}px;
    display: flex;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.palette.grey[4]};
    position: relative;

    ${InfoButton} {
      margin-left: 0.5em;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: flex-start;
  flex-wrap: wrap;

  p {
    color: ${({ theme }) => theme.palette.grey[1]};
    font-weight: ${({ theme }) => theme.typography.display};
    margin: 0;
    font-size: 1.2rem;
  }
`;

const BacWrapper = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  flex-wrap: wrap;

  p {
    color: ${({ theme }) => theme.palette.grey[1]};
    font-weight: 400;
    margin: 0;
    font-size: 1.2rem;
    padding-left: 30px;
  }
`;

const YourPaymentDetailsWidget = ({
  className,
  changeUsageDisableReason,
  bacs,
}) => {


  const classes = ['YourPaymentDetailsWidget', className];
  const history = useHistory();

  function onChangeBankDetails() {
    history.push(changeBankDetailsContainerPath());
  }

  const widgetRef = React.useRef();

  return (
    <StyledPaymentMethodWidgetDetails className={classes.filter((c) => !!c).join(' ')}>
      <h4>Payment Details</h4>
      <TextWrapper>
        <BacWrapper>
          {bacs &&
          <table>
            <tbody>
            <tr>
              <td><h3>Account Holder:</h3></td>
              <td><p>{bacs.account_holder_name}</p></td>
            </tr>
            <tr>
              <td><h3>Account Number:</h3></td>
              <td><p>{bacs.account_number}</p></td>
            </tr>
            <tr>
              <td><h3>Sort Code:</h3></td>
              <td><p>{bacs.sort_code}</p></td>
            </tr>
            <tr>
              <td><h3>Mandate Reference:</h3></td>
              <td><p>{bacs.reference}</p></td>
            </tr>
            </tbody>
          </table>
          }
        </BacWrapper>
      </TextWrapper>

      <Button
        fullWidth
        disableReason={changeUsageDisableReason}
        onClick={onChangeBankDetails}
      >
        Change Bank Details
      </Button>
      <FullWidthPaperContent className="subscriptionInfo" ref={widgetRef} />
    </StyledPaymentMethodWidgetDetails>
  );
};

YourPaymentDetailsWidget.displayName = 'YourPaymentDetailsWidget';

YourPaymentDetailsWidget.propTypes = {
  className: PropTypes.string,
  changeUsageDisableReason: PropTypes.string,
  bacs: PropTypes.object,
};

YourPaymentDetailsWidget.defaultProps = {
  className: null,
  changeUsageDisableReason: null,
  bacs: null,
};

export default YourPaymentDetailsWidget;
